import { defaultShapeTextParagraphs } from '@/lib/shapes/shape-text-frame'
import type { Paragraph } from '@/api/types/stowed-element'

/**
 * Paragraphs to write back to a shape acting as a text frame, never an empty array.
 *
 * A shape "is a text frame" purely by carrying `paragraphs`, and the wire marker that
 * preserves that identity across a reload (`editorShape.paragraphs`) is only emitted when
 * the array is non-empty — see `buildEditorShape` (WMPCM-8160). Chain reflow can legitimately drain
 * a frame to nothing, so writing `[]` would make it reload as a plain shape and silently drop out
 * of its chain. One empty paragraph keeps the frame a frame (WMPCM-7988).
 *
 * The styling of that paragraph is NOT immaterial, contrary to what this comment used to claim: a
 * reflow putting text back does replace the array wholesale, but the user can type into the drained
 * frame first, and `defaultShapeTextParagraphs()` would hand them AWPCHelvetica instead of the
 * shape's own font. `sliceOrSeed` preserves a style-carrying blank paragraph when a distribution drains a
 * frame (see `pushResult` there), so this branch is reached only by a shape that never had text —
 * where there is genuinely no font to preserve.
 */
export function paragraphsForWriteBack(paragraphs: Paragraph[]): Paragraph[] {
  return paragraphs.length > 0 ? paragraphs : defaultShapeTextParagraphs()
}
